import { defineMessages } from 'react-intl';

export default defineMessages({
    startCourse: {
        id: 'assign-course-upf.components.startCourse',
        defaultMessage: 'Queue new default course for rollover:'
    },
    setDefaultCourse: {
        id: 'assign-course-upf.components.setDefaultCourse',
        defaultMessage: 'Set a new default course:'
    },
    searchCourse: {
        id: 'assign-course-upf.components.searchCourse',
        defaultMessage: 'Search for a course'
    },
    selectGroup: {
        id: 'assign-course-upf.components.selectGroup',
        defaultMessage: 'Select grade'
    },
    defaultOptionCountry: {
        id: 'assign-course-upf.components.defaultOptionCountry',
        defaultMessage: 'Select country'
    },
    selectCourse: {
        id: 'assign-course-upf.components.selectCourse',
        defaultMessage: 'Select course'
    },
    noCoursesFound: {
        id: 'assign-course-upf.components.noCoursesFound',
        defaultMessage: 'No courses found'
    },
    schoolCourses: {
        id: 'assign-course-upf.components.schoolCourses',
        defaultMessage: 'School courses'
    },
    skillQuests: {
        id: 'assign-course-upf.components.skillQuests',
        defaultMessage: 'Skill Quests'
    },
    coursesActivityMastery: {
        id: 'assign-course-legacy.components.coursesActivityMastery',
        defaultMessage: 'Courses (Activity Mastery)'
    },
    newCourses: {
        id: 'assign-course-legacy.components.newCourses',
        defaultMessage: 'New Courses'
    },
    courses: {
        id: 'assign-course-legacy.components.courses',
        defaultMessage: 'Courses'
    },
    assignToYear: {
        id: 'assign-course-upf.components.assignToYear',
        defaultMessage: 'Assign to year'
    },
    optOutOfCourse: {
        id: 'assign-course-upf.components.optOutOfCourse',
        defaultMessage: 'Opt out of course'
    },
    assignToGroup: {
        id: 'assign-course-upf.components.assignToGroup',
        defaultMessage: 'Assign to group'
    }
});



// WEBPACK FOOTER //
// ./app/components/assign-course-upf/messages.js